import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-2 pb-10 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-89">
      {/* Background glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-accent/5 rounded-full blur-3xl pointer-events-none" data-id="element-90" />

      <div className="relative max-w-4xl mx-auto text-center" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-92">
          <img src="https://cdn.magicpatterns.com/uploads/wr4VuRDSQrQPLD6dLG96Ww/1000128798.png" alt="George Capital Coaching" className="h-48 sm:h-60 mx-auto -mb-4 mix-blend-lighten" data-id="element-93" />

          <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif font-bold text-white leading-tight mb-6" data-id="element-94">
            Cómo ordenar tus finanzas en 30 días{' '}
            <br className="hidden md:block" data-id="element-95" />
            <span className="text-brand-accent italic" data-id="element-96">
              (y recuperar el control de tu sueldo)
            </span>{' '}
            <br className="hidden md:block" data-id="element-97" />
            sin usar una sola hoja de Excel.
          </h1>

          <p className="text-lg sm:text-xl text-slate-300 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-98">
            El sistema pragmático para que tu dinero deje de desaparecer en
            gastos invisibles. Resultados reales en 4 semanas.
          </p>

          <div className="mb-10 flex justify-center" data-id="element-99">
            <img src="https://cdn.magicpatterns.com/uploads/1GzbSbfhewBTh7Tetum51u/Portada_como_ordenar_tus_finanzas_en_30_dias.png" alt="Mockup del eBook Cómo Ordenar Tus Finanzas en 30 Días — Método George Capital, mostrado en iPad y iPhone" className="w-full max-w-xl sm:max-w-2xl drop-shadow-[0_20px_40px_rgba(245,158,11,0.15)]" data-id="element-100" />
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-101">
            <a href="#cta" className="group relative inline-flex items-center justify-center gap-3 bg-brand-accent text-brand-dark px-8 py-4 rounded-lg font-bold text-lg sm:text-xl hover:bg-brand-accentHover transition-all hover:scale-105 active:scale-95 shadow-[0_0_40px_-10px_rgba(245,158,11,0.5)]" data-id="element-102">
              SÍ, QUIERO EL MÉTODO POR $199 MXN
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-103" />
            </a>

            <div className="flex items-center gap-2 text-sm text-slate-400 mt-4" data-id="element-104">
              <ShieldCheck className="w-4 h-4 text-brand-accent" data-id="element-105" />
              <span data-id="element-106">Acceso inmediato y de por vida</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}